
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";
import { Logger             } from "@/util/logger";
import {PanoramaSelector} from "@/components/panorama.selector";

export class PanoramaSelectorToggleAction extends Action {

  /** the panoramic controller that can actually do stuff for us */
  private _controller : PanoramaSelector = null;

  /** standard constructor */
  constructor(controller : PanoramaSelector) {
    super({
      key:   ActionType.PANO_SELECTOR_TOGGLE,
      type:  ActionType.PANO_SELECTOR_TOGGLE,
      label: 'Toggle Panorama Selector',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** fetch the panoramic controller */
  public controller(): PanoramaSelector {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.toggle();

    return true;
  }
}
